import Flex from "@/shared/components/common/Flex";
import Container from "@/shared/components/common/Container";
import Skeleton from "@/shared/components/common/Skeleton";

export default function DesktopBannerSkeleton() {
  return (
    <Flex
      className={
        "h-40 max-md:h-44 bg-primary justify-center items-center overflow-hidden relative max-md:hidden"
      }
    >
      <Container className={"items-center max-md:w-full"}>
        <Flex className="flex-col gap-y-2 max-md:items-center">
          <Skeleton className="w-48 h-5 rounded-full" />
          <Skeleton className="w-64 h-4 rounded-full" />
        </Flex>
      </Container>
    </Flex>
  );
}
